import { Injectable } from '@angular/core';
import { params } from '@app/configurations';

import { Action, Selector, State, StateContext } from '@ngxs/store';
import { RouterNavState } from '../router-nav/router-nav.state';
import { DefaultGlobalFilters, GlobalFilterNotFound } from './global-filters-state.actions';

import { GLOBAL_FILTERS_STATE_TOKEN, GlobalFiltersStateModel } from './global-filters-state.models';

export const DEFAULTS = {
  accountsDefaultFilter: '',
  PGDefaultFilter: '',
  campaignsDefaultFilter: 'status:ACTIVE;optimize:true',
  adGroupsDefaultFilter: '',
  criteriaDefaultFilter: '',
};

@Injectable()
@State<GlobalFiltersStateModel>({
  name: GLOBAL_FILTERS_STATE_TOKEN,
  defaults: {
    filterDefaults: {
      accountsDefaultFilter: DEFAULTS.accountsDefaultFilter,
      PGDefaultFilter: DEFAULTS.PGDefaultFilter,
      campaignsDefaultFilter: DEFAULTS.campaignsDefaultFilter,
      adGroupsDefaultFilter: DEFAULTS.adGroupsDefaultFilter,
      criteriaDefaultFilter: DEFAULTS.criteriaDefaultFilter,
    },
    errors: { notFoundError: null },
  },
})
export class GlobalFiltersState {
  @Selector()
  static notFoundError(data: GlobalFiltersStateModel) {
    return data.errors?.notFoundError;
  }

  @Selector()
  static filtersValues({ filterDefaults }: GlobalFiltersStateModel) {
    return filterDefaults;
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_PERFORMANCE_GROUP_QUERY)])
  static hasPGQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_DEST_PERFORMANCE_GROUP_QUERY)])
  static hasDestPGQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_CAMPAIGN_QUERY)])
  static hasCampaignQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_DEST_CAMPAIGN_QUERY)])
  static hasDestCampaignQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_AD_GROUPS_QUERY)])
  static hasAdGroupQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_DEST_AD_GROUPS_QUERY)])
  static hasDestAdGroupQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_CRITERIA_QUERY)])
  static hasCriteriaQuery(query): boolean {
    return typeof query === 'string';
  }

  @Selector([RouterNavState.queryParam(params.GLOBAL_FILTER_ACCOUNT_QUERY)])
  static hasAccountQuery(query): boolean {
    return typeof query === 'string';
  }

  @Action(GlobalFilterNotFound)
  globalFilterNotFound(
    { patchState, getState }: StateContext<GlobalFiltersStateModel>,
    { data }: GlobalFilterNotFound,
  ) {
    const { errors } = getState();

    patchState({
      errors: { ...errors, notFoundError: data },
    });
  }

  @Action(DefaultGlobalFilters)
  defaultGlobalFilters(
    { patchState, getState }: StateContext<GlobalFiltersStateModel>,
    { options }: DefaultGlobalFilters,
  ) {
    const { filterDefaults } = getState();

    patchState({
      filterDefaults: {
        ...filterDefaults,
        campaignsDefaultFilter: options?.showAllAccounts ? '' : DEFAULTS.campaignsDefaultFilter,
      },
    });
  }
}
